<template>
    <div class="tags" v-if="showTags">
        <ul>
            <li class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item.path)}" :key="index">
                <router-link :to="item.path" class="tags-li-title">
                    {{item.title}}
                </router-link>
                <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close"></i></span>
            </li>
        </ul>
        <!-- <div class="tags-close-box">
            <el-dropdown @command="handleTags">
                <el-button size="mini" type="primary">
                    标签选项<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu size="small" slot="dropdown">
                    <el-dropdown-item command="other">关闭其他</el-dropdown-item>
                    <el-dropdown-item command="all">关闭所有</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div> -->
    </div>
</template>

<script>
import bus from "@/vuex/eventBus";
    export default {
        data() {
            return {
                tagsList: []
            }
        },
        methods: {
            isActive(path) {
                return path === this.$route.fullPath;
            },
            // 关闭单个标签
            closeTags(index) {
                const delItem = this.tagsList.splice(index, 1)[0];
                const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
                if (item) {
                    delItem.path === this.$route.fullPath && this.$router.push(item.path);
                }else{
                    this.$router.push('/');
                }
            },
            // 关闭全部标签
            closeAll(){
                this.tagsList = [];
                this.$router.push('/');
            },
            // 关闭其他标签
            closeOther(){
                const curItem = this.tagsList.filter(item => {
                    return item.path === this.$route.fullPath;
                })
                this.tagsList = curItem;
            },
            // 设置标签
            setTags(route){
                if(route.fullPath == "/"){
                    let groupType = sessionStorage.getItem("groupType");
                    let page = "SystemMain";
                    if(groupType == null || groupType == "0" || groupType == "1"){
                        page = "SystemMain";
                    }else if(groupType == "2"||groupType == "5"){
                        page = "jChart";
                    }else if(groupType == "3" || groupType == "4"){
                        page = "SiteChart";
                    }else if(groupType == "6"){
                        page = "canteenMain";
                    }else if(groupType == "7"){
                        page = "SiteChart";
                    }else if(groupType == "8"){
                        page = "jChart";
                    }
                    this.$router.push({ path: "/"+page });
                    // if (sessionStorage.getItem("groupType") == "3" || sessionStorage.getItem("groupType") == "4"){
                    //     this.$router.push({ path: "/jChart" });
                    // }else{
                    //     this.$router.push({ path: "/SystemMain" });
                    // }
                    return;
                }
                // 禁止 入院办理流程 页面添加进去
                if(route.fullPath == "/OlderDetailAdd"){
                    return;
                }
                if(route.fullPath == "/OlderDetailAddBase" ||
                    route.fullPath == "/OlderDetailFeeChoose" || 
                    route.fullPath == "/OlderDetailFeeEnter"){
                    for (let i = 0, len = this.tagsList.length; i < len; i++) {
                        if(this.tagsList[i].path == "/OlderDetailAddBase"||
                            this.tagsList[i].path == "/OlderDetailFeeChoose" || 
                            this.tagsList[i].path == "/OlderDetailFeeEnter"){
                            this.tagsList.splice(i, 1);
                            break;
                        }
                    }
                }
                let isExist = false;
                let sameIndex = 0;
                if(this.tagsList != null){
                    isExist = this.tagsList.some((item,index) => {
                        sameIndex = index;
                        return item.path === route.fullPath;
                    })
                }
                if(!isExist){
                    if(this.tagsList.length >= 9){
                        this.tagsList.shift();
                    }
                    this.tagsList.push({
                        title: route.meta.title,
                        path: route.fullPath,
                        name: route.matched[1].components.default.name
                    })
                }else{
                    this.tagsList.splice(sameIndex,1);
                    this.tagsList.push({
                        title: route.meta.title,
                        path: route.fullPath,
                        name: route.matched[1].components.default.name
                    })
                }
                bus.$emit('tags', this.tagsList);
            },
            handleTags(command){
                command === 'other' ? this.closeOther() : this.closeAll();
            }
        },
        computed: {
            showTags() {
                return this.tagsList.length > 0;
            }
        },
        watch:{
            $route(newValue){
                if(newValue!=null){
                    this.setTags(newValue);
                }
            }
        },
        created(){
            if(this.$route!=null){
                this.setTags(this.$route);
            }
            // 监听关闭当前页面的标签页
            bus.$on('close_current_tags', () => {
                for (let i = 0, len = this.tagsList.length; i < len; i++) {
                    const item = this.tagsList[i];
                    if(item.path === this.$route.fullPath){
                        if(i < len - 1){
                            this.$router.push(this.tagsList[i+1].path);
                        }else if(i > 0){
                            this.$router.push(this.tagsList[i-1].path);
                        }else{
                            this.$router.push('/');
                        }
                        this.tagsList.splice(i, 1);
                        break;
                    }
                }
            })
        }
    }

</script>


<style>
    .tags {
        position: absolute;
        height: 30px;
        overflow: hidden;
        margin-top: -30px;
        width: 85%;
        margin-left: -5px;
    }

    .tags ul {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }

    .tags-li {
        float: left;
        margin: 3px 5px 2px 3px;
        border-radius: 3px;
        font-size: 12px;
        overflow: hidden;
        cursor: pointer;
        height: 23px;
        line-height: 23px;
        border: 1px solid #e9eaec;
        background: #fff;
        padding: 0 2px 0 6px;
        vertical-align: middle;
        color: #666;
        -webkit-transition: all .3s ease-in;
        -moz-transition: all .3s ease-in;
        transition: all .3s ease-in;
    }

    .tags-li:not(.active):hover {
        background: #f8f8f8;
    }

    .tags-li.active {
        color: #222222;
    }

    .tags-li-title {
        float: left;
        max-width: 90px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 3px;
        color: #666;
    }

    .tags-li.active .tags-li-title {
        color: #222222;
    }

    .tags-close-box {
        position: absolute;
        right: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 1px;
        text-align: center;
        width: 110px;
        height: 30px;
        background: #fff;
        box-shadow: -3px 0 15px 3px rgba(0, 0, 0, .1);
        z-index: 10;
    }

</style>
